import { BrandLogo } from '@/components/ui/BrandLogo'

export function LoginHeader() {
  return (
    <div className="text-center">
      <BrandLogo size="login" className="mb-2" />
    </div>
  )
}
